"use strict";
var Observable_1 = require('../../Observable');
var bindCallback_1 = require('../../observable/bindCallback');
Observable_1.Observable.bindCallback = bindCallback_1.bindCallback;
//# sourceMappingURL=bindCallback.js.map


//////////////////
// WEBPACK FOOTER
// ./~/rxjs/add/observable/bindCallback.js
// module id = 203
// module chunks = 2